/* Shared contact state: factual hours plus editable automatic/manual video copy.
 * Chat/video actions remain owned by the native Papiro handlers. This file only reads hours; it sends no chat/video requests. */
(function () {
  'use strict';
  if (window.PapiroContact) {
    window.PapiroContact.init(document);
    return;
  }
  var requests = Object.create(null);
  function cap(value) {
    var text = String(value || '');
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
  function setCopy(root, selector, value, rowSelector) {
    var element = root.querySelector(selector);
    if (!element) return;
    element.textContent = value || '';
    var row = rowSelector ? root.querySelector(rowSelector) : element;
    if (row) row.hidden = !value;
  }
  function paintHours(root, value) {
    var summary = root.querySelector('[data-contact-summary]');
    if (!summary || !value) return;
    summary.textContent = value;
    var mode = root.getAttribute('data-contact-hours-layout');
    if (mode !== 'filas' && mode !== 'tarjetas') return;
    // Only split complete day/time groups; unfamiliar text stays intact.
    var parts = String(value).split(/\s+·\s+/).map(function (part) {
      return /^([^:]+):\s+(.+)$/.exec(part.trim());
    });
    if (!parts.length || parts.some(function (part) { return !part; })) return;
    var list = document.createElement('dl');
    list.className = 'p-contact-hours p-contact-hours--' + mode;
    parts.forEach(function (part) {
      var row = document.createElement('div');
      row.className = 'p-contact-hours-row';
      var days = document.createElement('dt');
      days.textContent = cap(part[1]);
      var hours = document.createElement('dd');
      hours.textContent = part[2];
      row.appendChild(days);
      row.appendChild(hours);
      list.appendChild(row);
    });
    summary.replaceChildren(list);
  }
  function paint(root, data) {
    if (!root || !data || data.success !== true || typeof data.abierto !== 'boolean') return;
    var state = root.querySelector('[data-contact-state]');
    var text = root.querySelector('[data-contact-state-text]');
    var dot = root.querySelector('[data-contact-dot]');
    if (state && text) {
      state.hidden = false;
      state.classList.toggle('p-estado--abierto', data.abierto);
      text.textContent = data.texto ? cap(data.texto) : (data.abierto ? 'Abiertos ahora' : 'Ahora estamos cerrados');
    }
    if (dot) dot.classList.toggle('pc-dot--on', data.abierto);
    if (data.resumen) paintHours(root, data.resumen);
    if (root.getAttribute('data-contact-vc-mode') !== 'auto') return;
    var prefix = 'data-contact-vc-' + (data.abierto ? 'open-' : 'closed-');
    setCopy(root, '[data-contact-vc-title]', root.getAttribute(prefix + 'title'), '[data-contact-vc-title-row]');
    setCopy(root, '[data-contact-vc-text]', root.getAttribute(prefix + 'text'));
    // Keep the action available even when its label is intentionally blank in the editor.
    var button = root.querySelector('[data-contact-vc-button]');
    if (button) button.textContent = root.getAttribute(prefix + 'button') || '';
  }
  function requestHours(crm) {
    if (!requests[crm]) {
      var options = { headers: { Accept: 'application/json' } };
      try {
        if (window.AbortSignal && window.AbortSignal.timeout) options.signal = window.AbortSignal.timeout(7000);
      } catch (ignore) {}
      requests[crm] = window.fetch(crm + '/api/public/horario', options)
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; });
    }
    return requests[crm];
  }
  function init(scope) {
    scope = scope || document;
    var roots = [];
    if (scope.matches && scope.matches('[data-papiro-contact]')) roots.push(scope);
    if (scope.querySelectorAll) roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-papiro-contact]')));
    roots.forEach(function (root) {
      if (root.hasAttribute('data-contact-ready')) return;
      root.setAttribute('data-contact-ready', '');
      var summary = root.querySelector('[data-contact-summary]');
      if (summary) paintHours(root, summary.textContent);
      var forced = /(?:\?|&)horario=(abierto|cerrado)(?:&|$)/.exec(window.location.search);
      if (forced) {
        paint(root, {
          success: true, abierto: forced[1] === 'abierto',
          texto: forced[1] === 'abierto' ? 'te atendemos al momento' : 'ahora estamos cerrados — te contestamos en cuanto abramos'
        });
        return;
      }
      var crm = (root.getAttribute('data-crm') || '').replace(/\/+$/, '');
      if (!crm || !window.fetch) return;
      requestHours(crm).then(function (data) {
        if (root.isConnected) paint(root, data);
      });
    });
  }
  window.PapiroContact = { init: init };
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else init(document);
})();
